import _ from 'lodash';
import angular from 'angular';

class ArtistsController {
  /* @ngInject */
  constructor($rootScope, $scope, $state, HelperService) {
    const vm = this;

    vm.$onInit = () => {
      $rootScope.pageTitle = 'Artists';
      // $rootScope.pageDescription = ''

      const artists = vm.artists.docs.map(artist => {
        if (!artist.fields.assets.length) {
          return artist;
        }
        artist.hero = _.sample(HelperService.group(artist.fields.assets));
        artist.hero.type =
          artist.hero.entities[0].schema === 'video' ? 'video' : 'image';
        if (artist.hero.type === 'image') {
          artist.hero.entities = artist.hero.entities.filter(
            entity => entity.schema === 'image'
          );
        }
        return artist;
      });

      if (!$rootScope.disciplineMap) {
        $rootScope.disciplineMap = {};
      }

      $scope.$watch(
        () => $state.params.discipline,
        activeDiscipline => {
          vm.activeDiscipline = activeDiscipline;

          if ($rootScope.disciplineMap[activeDiscipline]) {
            vm.artists = $rootScope.disciplineMap[activeDiscipline];
            return;
          }

          let disciplineArtists = angular.copy(artists).map(artist => {
            artist.$score = 0;

            if (artist.fields.priority && artist.fields.priority.length) {
              if (artist.fields.priority[0].slug === 'high') {
                artist.$score += _.random(50, 100);
              }
              if (artist.fields.priority[0].slug === 'low') {
                artist.$score -= _.random(50, 100);
              }
            }

            if (activeDiscipline) {
              artist.$disciplineActive = false;

              const artistDisciplines = artist.fields.disciplines.terms.map(
                term => term.slug
              );

              if (artistDisciplines.indexOf(activeDiscipline) > -1) {
                artist.$disciplineActive = true;
                artist.$score += 10000;
              }
            } else {
              artist.$disciplineActive = true;
            }

            return artist;
          });

          disciplineArtists.sort((a, b) => {
            if (a.$score > b.$score) {
              return -1;
            }
            if (a.$score < b.$score) {
              return 1;
            }
            return 0;
          });

          $rootScope.disciplineMap[activeDiscipline] = disciplineArtists;

          vm.artists = disciplineArtists;
        }
      );
    };
  }
}

export default ArtistsController;
